import React, { Component, useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import KineticTicker from "@/components/KineticTicker";
import ResultsSection from "@/components/ResultsSection";
import MethodSection from "@/components/MethodSection";
import ExcelBonusSection from "@/components/ExcelBonusSection";
import StandardSection from "@/components/StandardSection";
import PricingSection from "@/components/PricingSection";
import FaqSection from "@/components/FaqSection";
import FooterSection from "@/components/FooterSection";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-ink-deep text-white flex items-center justify-center p-6">
          <div className="text-center">
            <p className="font-mono text-blood text-xs tracking-[0.3em] uppercase">Errore</p>
            <h1 className="font-display text-4xl font-black uppercase mt-3">Qualcosa è andato storto</h1>
            <button
              data-testid="error-reload-btn"
              onClick={() => window.location.reload()}
              className="mt-6 bg-blood hover:bg-blood-hot text-white font-display font-bold uppercase tracking-wider px-8 py-3"
            >
              Ricarica
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

const Landing = () => (
  <div className="min-h-screen bg-ink-deep text-white overflow-x-clip">
    <Navbar />
    <main>
      <HeroSection />
      <ResultsSection />
      <KineticTicker />
      <MethodSection />
      <ExcelBonusSection />
      <StandardSection />
      <PricingSection />
      <FaqSection />
    </main>
    <FooterSection />
    <FloatingWhatsApp />
  </div>
);

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <ErrorBoundary>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" theme="dark" toastOptions={{ style: { background: "#15151A", border: "1px solid rgba(229,9,20,0.4)", color: "#fff" } }} />
    </ErrorBoundary>
  );
}

export default App;
